// extracted by mini-css-extract-plugin
export var cardTitle = "_jw-1";
export var commentBubble = "_jw-e";
export var commentForm = "_jw-a";
export var commentInput = "_jw-b";
export var commentLabel = "_jw-d";
export var commentPrompt = "_jw-9";
export var csatCard = "_jw-0";
export var feedbackSection = "_jw-7";
export var starDisabled = "_jw-6";
export var starEmpty = "_jw-5";
export var starFilled = "_jw-4";
export var starWrapper = "_jw-3";
export var starsContainer = "_jw-2";
export var submittedComment = "_jw-c";
export var thankYouText = "_jw-8";